import React from 'react';
import { TapParticle } from '../../services/particleEffectsService';

interface TapParticlesProps {
  particles: TapParticle[];
  containerSize?: number; // If provided, use for scaling, else use window size
  zIndex?: number;
}

const TapParticles: React.FC<TapParticlesProps> = ({ particles, containerSize = 0, zIndex = 98 }) => {
  // If containerSize is 0, use window size
  const width = containerSize || window.innerWidth;
  const height = containerSize || window.innerHeight;

  return (
    <>
      {particles.map(particle => {
        const progress = particle.life / particle.maxLife;
        const opacity = Math.sin(Math.PI * (1 - progress)) * 0.9;
        const scale = particle.scale * (1 + Math.sin(Math.PI * progress) * 0.3);
        return (
          <div
            key={particle.id}
            style={{
              position: 'absolute',
              left: particle.x * width,
              top: particle.y * height,
              transform: `translate(-50%, -50%) scale(${scale}) rotate(${progress * 180}deg)`,
              fontSize: '1.2rem',
              opacity,
              pointerEvents: 'none',
              zIndex,
              filter: 'drop-shadow(0 0 4px rgba(255,255,255,0.8))',
            }}
          >
            {particle.emoji}
          </div>
        );
      })}
    </>
  );
};

export default TapParticles;
